import { Box, Typography } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { JxIconButton, JxTooltip } from '@jx';
import { useUserSetting } from '../../../contexts/UserSettingsContext.jsx';
import { emsToDisplay } from '../../../services/utils/DateFormat.js';
import deleteConfirmEngine from '../../../components/shared/DeleteConfirmEngine';
import './UmlPkgLibViewerRow.css';

/**
 * UmlPkgLibViewerRow — one selectable UmlPkgLib note (a saved package template).
 * Same entry-row-* card styling as LoadUmlNoteRow. Preview PNG lives inline in
 * note.body (previewPng key, alongside package/satellites/connectors) — no
 * separate preview note/engine, unlike UmlSchema.
 * @param {{ item: object, isSelected: boolean, onSelect: Function }} props
 */
export default function UmlPkgLibViewerRow({ item: note, isSelected, onSelect }) {
    const chipDateTimeFormat = useUserSetting('contentPanel.chipDateTimeFormat');

    /**
     * Reads the inline preview PNG from note.body (previewPng key). Falls back
     * to null on parse failure — body is always JSON here, this is just defensive.
     * @returns {string|null}
     */
    const getPreviewPng = () => {
        try {
            return JSON.parse(note.body)?.previewPng ?? null;
        } catch (error) {
            return null;
        }
    };
    const previewPng = getPreviewPng();

    /**
     * Opens the app-wide delete confirmation for this note.
     * @param {React.MouseEvent} e
     */
    const handleDelete = (e) => {
        e.stopPropagation(); // don't trigger onSelect
        deleteConfirmEngine.request(note);
    };

    return (
        <Box id={`UmlPkgLibItemRow-${note.rk}`} className="entry-row-wrapper">
            <Box
                id={`entry-row-${note.rk}`}
                className={`entry-row-card ${isSelected ? 'entry-row-card--selected' : ''}`}
                onClick={() => onSelect(note)}
            >
                <Box className="upvr-title-line">
                    <Typography className={`entry-row-title upvr-title ${isSelected ? 'entry-row-title--selected' : ''}`}>
                        {note.title || '(no name)'}
                    </Typography>

                    <JxTooltip title="Delete">
                        <JxIconButton icon={<DeleteOutlineIcon sx={{ fontSize: 16 }} />} onClick={handleDelete} className="upvr-delete" />
                    </JxTooltip>
                </Box>

                {note.remark && (
                    <Typography className="upvr-remark" sx={isDeleted ? { textDecoration: 'line-through' } : {}}>
                        {note.remark}
                    </Typography>
                )}

                {previewPng && <img className="upvr-thumb" src={previewPng} alt="" />}

                <Typography className="upvr-updated">{emsToDisplay(note.updatedOn, chipDateTimeFormat)}</Typography>
            </Box>
        </Box>
    );
}
